import React, { useEffect, useState } from 'react';
import { Table, DatePicker, Pagination } from 'antd';
import { AiFillEdit, AiFillEye, AiOutlineSearch } from 'react-icons/ai';
import { Link, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import CustomPaginator from '../../../../Components/CustomPaginator';
import DateRangeFiltering from '../../../../Components/DateRangeFiltering';
import useFetchListData from '../../../../hooks/useFetchListData';
import LoadingSpinner from '../../../../Components/LoadingSpinner';
import { formatDateTime } from '../../../../Components/formatDateTime';


const GSRListCom = ({user,apiEndpoint,detailsURL,detailsPermissionCode}) => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState('');
  const [dataStatus, setDataStatus] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const params = {
    page: currentPage,
    search: searchText,
    start_date: startDate,
    end_date: endDate,     
  };

  const { data, totalItems, isLoading, error, fetchData } = useFetchListData(`${apiEndpoint}`, params);

  useEffect(() => {
    fetchData();
  }, [currentPage, searchText, dataStatus, endDate,startDate]);

  const handleSearch = (value) => {
    setSearchText(value);
  };




  const dataSource = data?.flatMap((data,index) =>({
    key: index,
    id:data?.id,
    req_code: data?.req_code,
    created_by_text: data?.created_by_text,
    created_at: data?.created_at,
    issue_status: data.issue_status === 'Issued' ? <div className='bg-green-500 text-[#fff] w-[70px] text-center'>Issued</div> : data.issue_status === 'Partial' ? <div className='bg-blue-500 text-[#fff] w-[70px] text-center'>Partial</div> : <div className='bg-red-500 text-[#fff] w-[70px] text-center'>Raised</div>,

  }))

  


  const columns = [
    {
      title: 'SN',
      key: 'key',
      render: (text, record, index) => {
        return (currentPage - 1) * 10 + index + 1;
      },
    },
    {
      title: 'REQ CODE',
      dataIndex: 'req_code',
      key: 'req_code',
    },
    {
        title: 'Issue Status',
        dataIndex: 'issue_status',
        key: 'issue_status',
      },
    {
      title: 'Created By',
      dataIndex: 'created_by_text',
      key: 'created_by_text',
      responsive: ['md']
    },
    {
      title: 'Created at',
      dataIndex: 'created_at',
      key: '7',
      render: (created_at) => {
        const formattedDateTime = formatDateTime(created_at);
        return <span>{formattedDateTime}</span>;
      },
      responsive: ['md']
    },
    {
      title: 'ACTIONS',
      dataIndex: 'actions',
      render: (_, record) => (
        <div className='flex gap-2'>
          {user?.menu_permissions?.includes(`${detailsPermissionCode}`) && (
              <button onClick={() => navigate(`${detailsURL}${record.id}`)} className='rounded'>
              <AiFillEye className='text-[#2929ff] text-xl' />
            </button>
          )}
        </div>
      ),
    },

  ];






  return (
    <>
    <div className='container-fluid grid grid-cols-1'>
      <div className='page-header mb-2 px-1'>
        <div className="flex justify-between pt-5">
          <div className='page-title my-auto md:ml-5'>
            <h1 className='uppercase'>General SR List</h1>
          </div>     

          <div className='page-search-and-add-new-button md:flex my-auto md:mr-5'>
            <div className='hidden md:flex'>
                <DateRangeFiltering setEndDate={setEndDate} endDate={endDate} setStartDate={setStartDate} startDate={startDate} />
            </div>
            
            <div className='page-search ml-2 hidden md:block'>
              <div className='relative'>
                <input
                  className='page-search-input w-[200px] md:w-[214px] appearance-none focus:outline-none focus:bg-white focus:border-[#F35B5B]'
                  type='text'
                  name='search'
                  required
                  onChange={(e) => handleSearch(e.target.value)}
                  placeholder='Search here'
                />
                <div className='text-xl absolute top-[5px] right-3'>
                  <button className='page-search-button' type='submit'>
                    <AiOutlineSearch className='text-[#fff] mx-auto' />
                  </button>
                </div>
              </div>
            </div>

            {user?.primary_role == 8 && (
            <div className="add-new-button px-2 ml-1">
                  <Link to={`/new-ticket-request`}>Add Request</Link>
            </div>
            )}
          </div>

        </div>

        <div className='page-search md:hidden mt-4'>
            <div className='relative'>
              <input
                className='page-search-input w-[85%] md:w-[214px] appearance-none focus:outline-none focus:bg-white focus:border-[#F35B5B]'
                type='text'
                name='search'
                required
                onChange={(e) => handleSearch(e.target.value)}
                placeholder='Search here'
              />
              <div className='text-xl absolute top-[-5px] right-0'>
                <button className='page-search-button p-[17px] px-6' type='submit'>
                  <AiOutlineSearch className='text-[#fff] mt-[-10px] mx-[-10px]' />
                </button>
              </div>
            </div>
        </div>

        <div className='page-header py-4 justify-between md:hidden'>
            <DateRangeFiltering setEndDate={setEndDate} endDate={endDate} setStartDate={setStartDate} startDate={startDate} />
        </div>
      </div>


      {isLoading ? (
        <p><LoadingSpinner/></p>
      ) : (
        <>
        <div className='shadow-lg overflow-x-auto'>
          <Table 
              columns={columns}
              dataSource={dataSource} 
              pagination={false}
          />
          <div className='my-5'>
              <CustomPaginator 
                  setCurrentPage={setCurrentPage} 
                  currentPage={currentPage}
                  totalItems={totalItems}
              />
          </div>
        </div>
       </>
      )} 
    </div>
    </>
  );
};


const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(GSRListCom);